export default __webpack_public_path__ + "static/media/frontpage-background.34d9352f.jpg";